module.exports = __webpack_public_path__ + "img/orange-chevron-right.28e49116.svg";